import { FC, ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useHubStateStore } from 'shared/hooks/stores/useHubStateStore';
import { useSitemap } from 'shared/hooks/useSitemap';
import { useShallow } from 'zustand/react/shallow';

interface AutoOnboardingPathProps {
  element: ReactNode;
}

export const AutoOnboardingPath: FC<AutoOnboardingPathProps> = ({ element }) => {
  const sitemap = useSitemap();
  const { offerId } = useParams();

  const { finishedAt, extractionState } = useHubStateStore(
    useShallow((state) => ({
      finishedAt: state.finishedAt,
      extractionState: state.extractionState,
    })),
  );

  const shouldRedirectToOnboarding = !finishedAt && !extractionState;
  if (shouldRedirectToOnboarding) {
    return <Navigate to={sitemap.onboarding(offerId)} />;
  }

  return element;
};
